module.exports = __webpack_public_path__ + "media/images/signup-background-96cf2396eeaacb742b7c990788cb468a.jpg";